import { render, staticRenderFns } from "./Unread.vue?vue&type=template&id=378ff172&scoped=true&"
import script from "./Unread.vue?vue&type=script&lang=js&"
export * from "./Unread.vue?vue&type=script&lang=js&"
import style0 from "./Unread.vue?vue&type=style&index=0&id=378ff172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ff172",
  null
  
)

/* custom blocks */
import block0 from "./Unread.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports